import { createAction, props } from '@ngrx/store';
import { RouteDetails } from '../../../shared/models/route-details';

export const getRoutesSuccess = createAction(
  '[Tracks/API] Get Routes Success',
  props<{data: RouteDetails[], params: any}>()
);
export const getRoutesFailure = createAction(
  '[Tracks/API] Get Routes Failure',
  props<{error: any}>()
);
export const getRoutesSummarySuccess = createAction(
  '[Tracks/API] Get Routes Summary Success',
  props<{data: RouteDetails[], params: any, cacheParams?: any, unitIds?: number[]}>()
);
export const getRoutesSummaryFailure = createAction(
  '[Tracks/API] Get Routes Summary Failure',
  props<{error: any}>()
);
export type TracksApiActionsUnion = ReturnType<
  typeof getRoutesSuccess |
  typeof getRoutesFailure |
  typeof getRoutesSummarySuccess |
  typeof getRoutesSummaryFailure
  >;
